import { Spinner } from "react-bootstrap";

export default function AbpnSpinner() {
  return (
    <div className="d-flex justify-content-center p-4" role="status" aria-live="polite">
      <Spinner animation="border" variant="primary">
        <span className="visually-hidden">Loading</span>
      </Spinner>
    </div>
  );
}
